import { render, staticRenderFns } from "./WxEventHandlerEditDialog.vue?vue&type=template&id=7de8a929"
import script from "./WxEventHandlerEditDialog.vue?vue&type=script&lang=js"
export * from "./WxEventHandlerEditDialog.vue?vue&type=script&lang=js"
import style0 from "./WxEventHandlerEditDialog.vue?vue&type=style&index=0&id=7de8a929&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports